import { GetInvitedUsersForLogisticsPartyResponse as GetInvitedUsersForLogisticsPartyResponseCore } from '@amzn/coral_com-amazon-passportusermanagementservice';
import { modelRegistrySingleton } from '@amzn/ihm-js-coral-client';
import FULLY_QUALIFIED_TYPE_NAMES from '../constants/coralOperationTypes';
/**
 * Extended class to override the serialization behavior and modify the type definition.
 * In coral expected format of the __type value is different between RPC calls and HTTP binding calls.
 * for more [info](https://issues.amazon.com/SFOFFICE-362).
 */

class GetInvitedUsersForLogisticsPartyResponse extends GetInvitedUsersForLogisticsPartyResponseCore {
  static fromJson({ invitedUserList }) {
    return GetInvitedUsersForLogisticsPartyResponse.clone({ invitedUserList });
  }
}

GetInvitedUsersForLogisticsPartyResponse.fullyQualifiedTypeName =
  FULLY_QUALIFIED_TYPE_NAMES.GetInvitedUsersForLogisticsPartyResponse;
// Register concrete types for serialization/deserialization
modelRegistrySingleton.registerType(GetInvitedUsersForLogisticsPartyResponse);
export default GetInvitedUsersForLogisticsPartyResponse;
